import axios from "../axiosInstance";

const ProductAPI = {
  list: (params) => axios.get("products/", { params }),

  draft: () => axios.get("products/draft"),

  updateActiveStatus: (id) => axios.patch(`products/${id}/status`),

  storeBasicInfo: (payload) => axios.post("products/basic-info", payload),
  fetchStep1BasicDetails: (id) => axios.get(`products/${id}/basic-info`),

  updateStep2SinglePrice: (id, payload) => axios.patch(`products/${id}/pricing`, payload),
  fetchStep2SinglePrice: (id) => axios.get(`products/${id}/pricing`),

  updateStep2VariantPrice: (id, payload) => axios.patch(`products/${id}/variants`, payload),
  fetchStep2VariantPrice: (id) => axios.get(`products/${id}/variants`),

  updateStep4Description: (id, payload) => axios.patch(`products/${id}/description`, payload),
  fetchStep4Description: (id) => axios.get(`products/${id}/description`),

  updateStep5MediaVideo: (id, payload) => axios.patch(`products/${id}/media`, payload),
  fetchStep5Media: (id) => axios.get(`products/${id}/media`),

  preview: (id) => axios.get(`products/${id}/preview`),
  finalSubmit: (payload) => axios.post(`products/publish`, payload),

  updateOrder: (payload) => axios.post("products/sort-order", payload),
  updateStatus: (payload) => axios.post("products/update-status", payload),

  deleteItem: (id) => axios.delete(`products/${id}`),
  listProductsforDeal: () => axios.get("products/listProductsforDeal"),

  deleteStep5Media: (productId, type, key) => axios.delete(`products/${productId}/media/${type}/${encodeURIComponent(key)}`),

  bulkImport: (payload) => axios.post("products/bulk-import", payload)
};

export default ProductAPI;
